module.exports = __webpack_public_path__ + "img/2.317a61a5.webp";